import domready from "domready";
import { Accordion, Hamburger, MobileMenuDrawer } from '@doodl/slate';
import Carousel from "./carousel";
import { CountUp } from "countup.js";
import ReactForm from "./react-form";
import Map from "./map";
import Registration from './registration';
import Lightbox from './lightbox';
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

// Init mobile menu
const menuDrawer = new MobileMenuDrawer();
const mainEl = document.querySelector('body');
// Init hamburger menu
new Hamburger({
    onOpen: () => {
        mainEl.classList.add('mobile-menu-open');
        menuDrawer.open();
    },
    onClose: () => {
        menuDrawer.close();
        mainEl.classList.remove('mobile-menu-open');
    },
});

new Accordion({
    selector: ".mobile-menu-drawer--items .has-children .menu-item--children, .faqblock--wrapper .faqblock--content",
});

Carousel(".image-carousel", {
    wrapAround: true,
    autoPlay: 2000,
});

let mapFlyTo;

Map('.development-map', {
    cooperativeGestures: true,
    zoom: 15,
    addMarkers: (Marker) => ({ target: mapInstance}) => {

        let first = true;
        let hasSecondaryMarkers = false;
        const bounds = [];

        document.querySelectorAll('[data-long-lat]').forEach(el => {
            const longLat = el.getAttribute('data-long-lat').split(',');
            bounds.push(longLat);

            new Marker({
                color: '#00B5E2',
                scale: 1.5,
            })
                .setLngLat(longLat)
                .addTo(mapInstance);

            if (first) {
                mapInstance.setCenter(longLat);
            }

            first = false;
        });

        document.querySelectorAll('[data-sec-long-lat]').forEach(el => {
            const longLat = el.getAttribute('data-sec-long-lat').split(',');
            bounds.push(longLat);
            hasSecondaryMarkers = true;

            new Marker({
                scale: 1,
                color: '#362746'
            })
                .setLngLat(longLat)
                .addTo(mapInstance);
        });

        if (hasSecondaryMarkers && bounds.length) {
            mapInstance.fitBounds(bounds, {
                padding: 80,
                maxZoom: 14,
            });
        }
        
        mapFlyTo = function(longLat) {
            mapInstance.flyTo({
                center: longLat,
                essential: true,
            });
        }
    }
});

Carousel(".homes-carousel", {
    wrapAround: true,
    setGallerySize: false,
    pageDots: false,
},inst => {
    // Make thumbnails clickable
    inst.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        if ( !cellElement ) {
            return;
        }

        // Navigate to development URL if currently selected cell is clicked
        if (inst.selectedIndex === cellIndex) {
            const href = cellElement.getAttribute('data-development-url');
            if (href) {
                window.location.href = href;
            }
        }
        inst.selectCell(cellElement, false, false);
    });

    // Trigger map fly to selected development on map
    inst.on( 'change', function (index) {
        if (typeof mapFlyTo === "function") {
            const newEl = inst.cells[index];
            const longLatStr = newEl?.element.getAttribute('data-long-lat');
            if (longLatStr) {
                mapFlyTo(longLatStr.split(","));
            }
        }
    });
});

domready(() => {
    document.querySelectorAll('.statistic').forEach(el => {
        new CountUp(el, el.innerHTML,{
            enableScrollSpy: true,
            scrollSpyOnce: true,
            scrollSpyDelay: 200,
            duration: 3,
        });
    });
});
Lightbox();
ReactForm();
Registration();

library.add(faCaretDown);
dom.watch();